import axios from 'axios'

// 添加单词本
export const addWordBook = (userName, bookData) => {
  return axios.post(`/wordBook/user/${userName}/addBook`, bookData)
}

// 查找单词本列表
export const getWordBooks = (userName) => {
  return axios.get(`/wordBook/user/${userName}/getWordBooks`)
}

// 删除单词本
export const deleteWordBook = (userName, bookName) => {
  return axios.delete(`/wordBook/user/${userName}/deleteWordBook/${bookName}`)
}

// 把单词添加到单词本
export const addWordToBook = (userName, bookName, wordData) => {
  return axios.post(`/wordBook/user/${userName}/bookName/${bookName}/addWord`, wordData)
}

// 分页查询单词本单词
export const getBookWordsList = (userName, bookName, pageNo, pageSize) => {
  return axios.get(`/wordBook/user/${userName}/book/${bookName}/getList`, {
    params: { pageNo, pageSize }
  })
}

// 查找单词本全部单词
export const getBookAllWords = (userName, bookName) => {
  return axios.get(`/wordBook/user/${userName}/book/${bookName}/getAll`)
}

// 删除单词本的单词
export const deleteWordFromBook = (userName, bookName, wordName) => {
  return axios.delete(`/wordBook/user/${userName}/book/${bookName}/deleteWord/${wordName}`)
}

// 单词本改名
export const updateBookName = (userName, oldBookName, newBookName) => {
  return axios.put(`/wordBook/${userName}/updateBookName/${oldBookName}`, null, {
    params: { bookName: newBookName }
  })
}

// 导出单词本
export const exportWordBook = (userName, bookName) => {
  return axios.get(`/wordBook/user/${userName}/book/${bookName}/export`, {
    responseType: 'blob' // 设置响应类型为blob，用于处理文件下载
  })
}

// 批量添加熟词
export const addMasterList = (userName, bookName, masterList) => {
  return axios.post(`/wordBook/user/${userName}/book/${bookName}/masterList`, masterList)
}
